import React, {useEffect, useState} from "react";

const ProfileStatus = ({status, putStatus}) => {

    let [editMode, setEditMode] = useState(false);
    let [statusState, setStatusState] = useState(status);

    useEffect(() => {
        setStatusState(status)
    }, [status]);

    const sendStatus = (e) => {
        setEditMode(false);
        putStatus(statusState)
    };

    return(
        <div>
            {!editMode && <p onClick={() => setEditMode(true)}>{status ? status : "Отсутсвует"}</p>}
            {editMode &&
                <input type="text" autoFocus={true}
                       onBlur={sendStatus}
                       value={statusState}
                       onChange={(e) => setStatusState(e.target.value)}
                />
            }
        </div>
    )
};

export default ProfileStatus